import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {FormProvider, useForm} from 'react-hook-form'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM, SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {startProcessWashBatch} from '../../../../services'
import {useKTable} from '../../../../../../contexts/KTableProvider'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

const ModalStartWash: FC<Props> = ({show, setShow}) => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {setUpdateTable, clearSelected} = useKTable()
  const [loading, setLoading] = useState<boolean>(false)
  const methods = useForm()
  const {handleSubmit} = methods

  const handleClose = () => {
    setShow(false)
  }

  useEffect(() => {
    // setValue()
  }, [])
  const onSubmit = async (data: any) => {
    try {
      const {
        id,
        lugarLavado,
        proveedorId,
        puntoId,
        fechaRealLavado,
        fechaRealSalida,
        fechaEntregaProveedor,
        fechaProgramadaProveedor,
      } = currentTabItem.detailRow

      let obj = {
        id,
        lugarLavado,
      }
      setLoading(true)
      let isType =
        currentTabItem.typeAdmin === 'COMPAÑÍA'
          ? {...obj, fechaRealSalida, puntoId, tipoLavado: currentTabItem.typeWash, fechaRealLavado}
          : {
              ...obj,
              fechaEntregaProveedor,
              fechaProgramadaProveedor,
              tipoLavado: currentTabItem.typeWash,
              proveedorId,
            }
      const {data: response} = await startProcessWashBatch(isType)
      if (!response.error) {
        ShowSnackBar(SUCCESS_MESSAGE_CREATE)
        setUpdateTable(true)
        clearSelected()
        setShow(false)
        changeCurrentTabItem({
          ...currentTabItem,
          typeAdmin: '',
          typeProcess: '',
          isStartLaundry: false,
          isFinishOut: false,
          isFinishLaundry: false,
          isCancel: false,
          detailRow: null,
        })
        setLoading(false)
      } else {
        setLoading(false)
        ShowSnackBar(response.message, 'error')
      }
    } catch (error) {
      setLoading(false)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Iniciar Lavado</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='mb-8'>
                <h6>
                  Se procederá a iniciar el lavado para el lote Nro.{' '}
                  {currentTabItem.detailRow?.nroOrdenLote}
                </h6>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalStartWash}
